<template>
  <transition name="modal">
    <div class="modal-mask text-left">
      <div class="modal-wrapper">
        <div class="modal-container child">
          <div class="modal-body">
            <div class="form-group">
              <div class="info">{{ msg }}</div>
            </div>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button
                class="btn btn-danger"
                @click="confirmAction()">
                {{ actionName }}
              </button>
              <button
                class="modal-default-button btn btn-default"
                @click="$emit('close')">
                Close
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import EventBus from '../services/eventBus.js';

export default {
	// eslint-disable-next-line vue/require-prop-types
	props: ['msg', 'action', 'actionName',],
	data() {
		return {};
	},
	methods: {
		confirmAction() {
			EventBus.$emit(this.action);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/ModalConfirm.vue